import axios from "axios";
import {
  getBlogsSuccess,
  getBlogsError,
  fetchBlogsStart,
} from "../slices/blogsSlice";
import { tmpHeader } from "../../utils/helper";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchBlogs = () => async (dispatch) => {
  dispatch(fetchBlogsStart());
  try {
    const res = await axios.get(`${API_URL}/blogs`, {
      headers: tmpHeader(),
    });
    dispatch(getBlogsSuccess(res.data.data));
  } catch (err) {
    console.log("Get Blogs Error:", err.response);
    dispatch(getBlogsError(err.response.data.error));
  }
};

export const fetchBlogById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/blogs/${id}`, {
      headers: tmpHeader(),
    });
    dispatch(getBlogsSuccess([res.data.data]));
  } catch (err) {
    console.log("Get Blog Error:", err.response);
    dispatch(getBlogsError(err.response.data.error));
  }
};
